<template>
  <ion-app>
    <SupervisionBanner />
    <CriticalIncidenciaBanner />
    <SidebarMenu v-if="userAuth().can('view sidebar')"></SidebarMenu>
    <ion-router-outlet id="main-content" />
  </ion-app>
</template>

<script lang="ts">
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import SidebarMenu from '@/components/SidebarMenu.vue';
import SupervisionBanner from '@/components/SupervisionBanner.vue';
import CriticalIncidenciaBanner from '@/components/CriticalIncidenciaBanner.vue';
import userAuth from '@/composables/userAuth';

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    SidebarMenu,
    SupervisionBanner,
    CriticalIncidenciaBanner,
  },
  setup() {
    return { userAuth };
  }
});
</script>